var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#5BA1E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.07142 12.5004C9.80911 11.2227 10.8858 10.1738 12.1824 9.46983C13.4789 8.76584 14.945 8.43412 16.4183 8.51133C17.8917 8.58855 19.315 9.0717 20.5309 9.90736C21.7468 10.743 22.7079 11.8987 23.308 13.2465M7.23145 10.0157L7.96086 13.1753C8.08509 13.7134 8.62204 14.0489 9.16017 13.9247L12.3197 13.1953M22.9279 20.5003C22.1902 21.778 21.1135 22.8268 19.8169 23.5308C18.5203 24.2348 17.0543 24.5665 15.581 24.4893C14.1076 24.4121 12.6843 23.9289 11.4684 23.0933C10.2525 22.2576 9.29139 21.102 8.6913 19.7542M24.7678 22.9849L24.0384 19.8254C23.9142 19.2872 23.3772 18.9517 22.8391 19.0759L19.6796 19.8053",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu5);
export default __webpack_public_path__ + "static/media/menu5.b15af18ca23775976b628ca3d89df3e3.svg";
export { ForwardRef as ReactComponent };